<template>
	<BaseCenteredMessage v-if="error">
		<template #title>{{ errorTitles[error] }}</template>
		<template v-if="error === 'no-deletion-request'" #details>
			There is no account deletion request for your user. <br />
			You can start the process from you profile settings page.
		</template>
		<template v-else-if="error === 'link-expired'" #details>
			This confirmation link has expired. <br />
			You may start the process again from you profile settings page.
		</template>
		<template v-else #details>
			There was an issue deleting your account. <br />
			Please contact support at
			<a href="mailto:support@birdeatsbug.com?subject=In-app support" class="link-blue">
				support@birdeatsbug.com
			</a>
			.
		</template>
		<template #actions>
			<RouterLink v-if="error === 'unknown'" class="button-green" to="/"> Back to my workspace </RouterLink>
			<RouterLink v-else class="button-green" to="/settings/account/profile"> Profile settings </RouterLink>
		</template>
	</BaseCenteredMessage>

	<BaseCenteredMessage v-else>
		<template #title>Account deletion confirmation</template>
		<template #details>
			When you proceed with this step, your account deletion will be completed. Keep in mind that this action is
			irreversible and cannot be undone.
		</template>
		<template #actions>
			<form ref="form" @submit.prevent="confirmDeletion">
				<BaseButton class="button-red w-full mb-16 justify-center" type="submit" :loading="isDeleting">
					Delete my account
				</BaseButton>
			</form>
			<RouterLink class="mx-auto text-center block link-gray text-strong-base" to="/">
				Cancel and go back to my workspace
			</RouterLink>
		</template>
	</BaseCenteredMessage>
</template>

<script>
import {useTitle} from 'shared/composables/useTitle'

export default {
	name: 'AccountDeleteConfirmation',
	setup() {
		return {title: useTitle('Confirm account deletion')}
	},
	data() {
		return {
			isDeleting: false,
			error: null,
			errorTitles: {
				'no-deletion-request': 'Account deletion request not found',
				'link-expired': 'Account deletion link expired',
				unknown: 'Account deletion error',
			},
		}
	},
	watch: {
		isDeleted(isDeleted) {
			if (!isDeleted) return
			this.title = 'Account deletion successful'
		},
		error(error) {
			if (!error) return
			this.title = this.errorTitles[error]
		},
	},
	methods: {
		async confirmDeletion() {
			if (this.isDeleting) return
			this.isDeleting = true
			try {
				await this.$api.delete('/users')
				await this.$routerHelpers.replace('/account-deleted')
			} catch (error) {
				switch (error.statusCode) {
					case 404:
						this.error = 'no-deletion-request'
						break
					case 410:
						this.error = 'link-expired'
						break
					default:
						this.error = 'unknown'
						break
				}
				this.isDeleting = false
			}
		},
	},
}
</script>
